<template>
  <base-box class="order-card animate__animated" :class="{ fadeOut: isActive }">
    <div @click="$emit('open-order', oOrder)" class="cursor-pointer">
      <!-- Line 1 -->
      <div>
        <p
          v-if="
            oOrder.payment.payers[0].user && oOrder.payment.payers[0].user.name
          "
          class="order-name"
        >
          <verified-badge
            title="Pedido Online"
            :origin="oOrder.origin"
          ></verified-badge>
          {{
            oOrder.position &&
            oOrder.delivery.type === DeliveryType.GET_ON_PLACE
              ? `${oOrder.payment.payers[0].user.name} - Senha ${oOrder.position}`
              : oOrder.payment.payers[0].user.name
          }}
        </p>
        <p v-else class="order-name">
          {{
            oOrder.position
              ? `Senha ${oOrder.position}`
              : StringLanguage.customerNotAssigned
          }}
        </p>
      </div>

      <!-- Line 2 -->
      <div class="row mb_20">
        <div class="col-lg-6 col-md-6 col-xs-6">
          <p class="sublabel">Valor total</p>
          <p>{{ Utils.convertMoney(oOrder.total) }}</p>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-6 text-right">
          <p class="sublabel order-number">
            <b> Pedido #{{ oOrder.order_id }} </b>
          </p>
          <p>{{ this.getArrivedTime(oOrder.created_at) }}</p>
        </div>
      </div>

      <!-- Line 3 -->
      <div class="row mb_20">
        <div class="col-lg-12">
          <p class="sublabel">Entrega</p>
          <div class="address">
            <i class="fal fa-map-marker-alt"></i>
            <p class="address-name" :title="generateAddr(oOrder.delivery.address)" v-if="oOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS">
              {{ generateAddr(oOrder.delivery.address) }}
            </p>
            <p class="address-name" :title="StringLanguage.withdrawAtCounter"  v-else>{{ StringLanguage.withdrawAtCounter }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Line 4 -->
    <div class="mb_20">
      <div
        v-if="oOrder.status != Status.FINISHED && !timerId"
        class="d-flex align-stretch"
      >
        <base-button
          v-if="oOrder.status === Status.IN_PRODUCTION"
          @click="changeStatus(oOrder.id, Status.ON_DELIVERY)"
          :text="
            oOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS
              ? StringLanguage.onDelivery
              : 'Pronto para retirada'
          "
          design="kanban done"
          class="w-100 mr_7"
        />
        <base-button
          @click="changeStatus(oOrder.id, Status.FINISHED)"
          :text="StringLanguage.finish"
          design="kanban finish"
          class="w-100"
          :class="{ ml_7: oOrder.status === Status.IN_PRODUCTION }"
        />
      </div>
      <base-button
        v-if="timerId"
        @click="undoChangeStatus(oOrder)"
        :text="statusChangeTimer | timerLabel"
        design="kanban undo"
        class="w-100"
      />
      <div
        v-if="oOrder.status === Status.FINISHED && !timerId"
        class="order-finished"
      >
        Pedido finalizado
      </div>
    </div>

    <!-- <div class="address-n-actions">
            <div @click="$emit('open-order', oOrder)" class="address">
              <p><i class="fas fa-map-marker-alt icon"></i></p>
              <p v-if="oOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS">{{ generateAddr(oOrder.delivery.address) }}</p>
              <p v-else>{{StringLanguage.withdrawAtCounter}}</p>
            </div>
            <div @click="openActions(oOrder.order_id)" class="icon-action" v-if="oOrder.status != Status.FINISHED">
              <span>
                  <i v-show="!open_actions[oOrder.order_id]" class="fas fa-ellipsis-h-alt"></i>
                  <i v-show="open_actions[oOrder.order_id]" class="fas fa-times"></i>
              </span>
            </div>
        </div>

        <div class="row change-state cursor-pointer" :class="{'open': open_actions[oOrder.order_id]}">
            <div class="col-lg-6 col-xs-6 state-delivery" v-if="oOrder.status==Status.IN_PRODUCTION" @click="changeStatus(oOrder.id, Status.ON_DELIVERY)" >
                <p><span class="color-white">{{oOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS ? StringLanguage.onDelivery : StringLanguage.clientWithdrewAtTheCounter}}</span></p>
            </div>
            <div :class="oOrder.status === Status.IN_PRODUCTION ? ['col-lg-6 col-xs-6'] : ['col-lg-12 col-xs-12']" class="state-finished" @click="changeStatus(oOrder.id, Status.FINISHED)" >
                <p><span class="color-white">{{StringLanguage.finish}}</span></p>
            </div>
        </div> -->
  </base-box>
</template>
<script>
import Vue from "vue";
import { Status } from "easyjs/lib/Schema/Order";
import { DeliveryType } from "easyjs/lib/Schema/Delivery";
import Utils from "@/utils";
import BrasilStates from "@/plugins/states";

import BaseBox from "@/components/Box";
import BaseLabel from "@/components/Label";
import BaseButton from "@/components/Button";

import VerifiedBadge from "@/containers/Users/VerifiedBadge";

export default {
  data() {
    return {
      statusChangeTimer: 0,
      timerId: null,
      open_actions: {},
      drawerDetail: false,
      Status,
      Utils,
      BrasilStates,
      DeliveryType,
      isActive: null,
    };
  },
  props: {
    oOrder: Object,
  },
  created() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      if (this.oOrder.schedule) {
        const currentTime = new Date().getTime();
        const scheduledTime = new Date(this.oOrder.schedule.date).getTime();
        const timerSeconds = this.oOrder.schedule.timer / 1000;

        const secondsPassed = Math.trunc((currentTime - scheduledTime) / 1000);
        if (secondsPassed < timerSeconds) {
          this.timer(timerSeconds - secondsPassed);
        }
      }
    },
    timer(seconds) {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.statusChangeTimer = seconds;
      this.timerId = setInterval(() => {
        if (this.statusChangeTimer > 0) {
          this.statusChangeTimer--;
        } else {
          this.resetTimer();
        }
      }, 1000);
    },
    resetTimer() {
      this.statusChangeTimer = 0;
      clearInterval(this.timerId);
      this.timerId = null;
    },
    undoChangeStatus(order) {
      const originalStatus = this.oOrder.status;
      this.$parent.$emit(
        "remove-order-from-change-status",
        this.oOrder.schedule
      );
    },
    getArrivedTime(createdAt) {
      if (!createdAt) return "";

      const milliseconds = Utils.toMilliseconds(createdAt);
      var temp = Math.floor(milliseconds / 1000);
      var days = Math.floor((temp %= 31536000) / 86400);

      if (days) {
        return Utils.dateParse(createdAt).replace(" ", " (") + ")";
      }

      return `${StringLanguage.hasArrived} ${Utils.millisecondsToStr(
        milliseconds
      )}`;
    },
    changeStatus(id, status) {
      this.isActive = true;
      setTimeout(() => {
        this.isActive = false;
      }, 1000);
      setTimeout(() => {
        const originalStatus = this.oOrder.status;
        this.$parent.$emit("change-status", {
          ...this.oOrder,
          id,
          status,
          originalStatus,
        });
      }, 500);
    },
    openActions(order_id) {
      Vue.set(this.open_actions, order_id, !this.open_actions[order_id]);
    },
    generateAddr(oAddress) {
      if (!oAddress) return "Erro no endereço";

      let stringAddress = `${oAddress.address}`;

      if (oAddress.number !== 'null') stringAddress += `, ${oAddress.number}`;
      if (oAddress.complement) stringAddress += ` (${oAddress.complement})`;

      const shortNameState = BrasilStates.getShortNameByName(oAddress.state);

      stringAddress += ` - ${oAddress.region} - ${oAddress.city}/${shortNameState}`;

      return stringAddress;
    },
    getStatus(status) {
      switch (status) {
        case 2:
          return StringLanguage.inProduction;
        case 3:
          return StringLanguage.onDelivery;
        case 4:
          return StringLanguage.finished;
      }
    },
  },
  watch: {
    oOrder() {
      this.resetTimer();
      this.startTimer();
    },
  },
  filters: {
    timerLabel(timer) {
      return `Desfazer (${timer}s)`;
    },
  },
  components: {
    BaseBox,
    BaseLabel,
    BaseButton,
    VerifiedBadge,
  },
};
</script>
<style scoped>
.order-finished {
  background: #414347;
  border-radius: 5px;
  color: #999999;
  border: 1px solid #414347;
  font-size: 12px;
  line-height: 15px;
  padding: 10px;
  text-align: center;
}

.animate__animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}

@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}

@-webkit-keyframes fadeDown {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeDown {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeDown {
  -webkit-animation-name: fadeDown;
  animation-name: fadeDown;
}
.order-card {
  margin-bottom: 20px;
  padding-bottom: 0;
  position: relative;
}
.order-name {
  font-size: 16px;
  font-weight: bold;
  color: var(--title-card);
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #494949;
}
.order-label span {
  border: 1px solid var(--default);
  color: var(--default);
  font-weight: 900;
  padding: 3px 5px;
  border-radius: 3px;
  opacity: 0.8;
}
.sublabel {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--title-card);
  font-weight: bold;
}

.sublabel.order-number {
  color: var(--default);
}

.sublabel + p {
  margin-top: 10px;
  font-size: 12px;
  color: var(--title-card);
}

.sublabel + .address {
  display: flex;
  margin-top: 10px;
  align-items: center;
}

.sublabel + .address p {
  font-size: 12px;
  line-height: 15px;
  color: var(--title-card);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.sublabel + .address i {
  font-size: 15px;
  color: #ffffff4c;
  margin-right: 10px;
}

.address-n-actions {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.address-n-actions .address {
  display: flex;
  font-size: 1.3em;
  color: #aaa;
}

.address-n-actions .address .icon {
  margin-right: 10px;
}

.icon-action {
  padding: 5px 6px;
  background: var(--default);
  color: white;
  font-size: 1.4em;
  border-radius: 3px;
  opacity: 0.8;
}

.change-state {
  margin-right: -20px;
  margin-left: -20px;
  opacity: 0.8;
  overflow: hidden;
  height: 0;
  transition: 0.1s all linear;
}

.change-state.open {
  height: 41px;
}

.change-state .state-delivery {
  background: var(--default);
  padding: 15px;
  font-size: 1.1em;
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
}

.change-state .state-finished {
  background: #0ba584;
  padding: 15px;
  font-size: 1.1em;
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
}

.color-white {
  color: white !important;
}

@media (max-width: 365px) {
  .state-btn {
    min-height: 47px;
  }
}

@media screen and (max-width: 991px) {
  .order-name {
    font-size: 14px;
  }
}
</style>
